import angular from 'angular';

module.exports = angular.module('common.filters.titlecase', [
  require('common/filters/wordcase'),
])
.filter('titlecase', wordcaseFilter => {
  return input => {
    if (typeof input === 'number') {
      input = String(input);
    } else if (typeof input !== 'string') {
      return '';
    }

    return wordcaseFilter(input).replace(/\w\S*/g, word => {
      return word.charAt(0).toUpperCase() + word.substr(1).toLowerCase();
    });
  };
})
.name;



/** WEBPACK FOOTER **
 ** ./javascripts/common/filters/titlecase.js
 **/